import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import ReportProblem from 'root/ReportProblem/ReportProblem';
import Router from 'root/Router/Router';
import SentryRouteTracker from 'root/SentryRouteTracker/SentryRouteTracker';

import { useApp } from './App.logic';

const App: React.FC = () => {
  useApp();
  return (
    <BrowserRouter>
      <SentryRouteTracker />
      <ReportProblem />
      <Router />
    </BrowserRouter>
  );
};
export default App;
